import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { contactUrls } from "../../URL/ApplicationUrls";
import { Contact } from "../Contact";
import { updateSuccessMessage } from "../../Messages/successMessages";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useUpdateContact = (contactId: number | string | undefined) => {
  return useMutation({
    mutationFn: async (contact: Contact) => {
      await axios.put(contactUrls.base.apiUrl, contact);
    },
    onSuccess: async () => {
      toast.success(updateSuccessMessage(contactId, "Contact"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
